import { ApplePayWithMerchantIndentifier } from '../actions/applePay';

export const isApplePaySupported = () =>
    window.ApplePaySession?.supportsVersion(3) &&
    window.ApplePaySession?.canMakePayments();

export const isApplePayCardActive = async (
    applePayInstance: ApplePayWithMerchantIndentifier,
) =>
    isApplePaySupported() &&
    (await window.ApplePaySession?.canMakePaymentsWithActiveCard(
        applePayInstance.merchantIdentifier,
    ));
